import React from "react";

// Mimic the interface of `react-svg-inline` while using `gatsby-plugin-react-svg`
// This is so we can import components from the 2017 soet site without too much faff
// svg should be the result of importing a local svg `import mySvg from "./local-svg.svg"`
export default ({ svg: Svg, ...other }) => <Svg {...other} />;
